import { useTranslation } from "react-i18next";
import { styled } from "@mui/material";
import Modal from "components/Modals/Modal";
import NewMessageForm from "./NewMessageForm";

const ModalStyled = styled(Modal)(({ theme }) => ({
  "& .wrapper": {
    width: "800px",
    height: "max-content",
  },
  [theme.breakpoints.down("md")]: {
    "& .wrapper": {
      width: "650px",
    },
  },
}));

const NewMessageModal = ({
  isOpen,
  onClose,
  messageType,
  recipients = [],
  recipientOptions = [],
}) => {
  const { t } = useTranslation();
  const translationTypeKey = messageType === "email" ? "Email" : "Sms";

  return (
    <ModalStyled
      isOpen={isOpen}
      onClose={onClose}
      title={t(`NewMessageModal.${translationTypeKey}.Title`)}
    >
      {isOpen && (
        <NewMessageForm
          messageType={messageType}
          recipients={recipients}
          recipientOptions={recipientOptions}
          onSubmit={onClose}
        />
      )}
    </ModalStyled>
  );
};
export default NewMessageModal;
